import { createSelector } from 'reselect'
import getHasSampledProductDataSelector from 'modules/product/redux/selectors/get-has-sampled-product-data'
import getImageToDisplayOnCardUtil from 'containers/ProductCollection/components/Item/redux/selectors/get-image-to-display-on-card/utils'

/**
 * @param productVariantSample
 * @returns {OutputSelector<[function(*): VariantWasSampledReduxItem], *, (...args: SelectorResultArray<[function(*): VariantWasSampledReduxItem]>) => *, GetParamsFromSelectors<[function(*): VariantWasSampledReduxItem]>, {clearCache: () => void}> & {clearCache: () => void}}
 */
const getImageToDisplayOnCardSelector = ({ productVariantSample }) => createSelector(
  getHasSampledProductDataSelector(productVariantSample?.product_id),
  (sampledData) => {
    return getImageToDisplayOnCardUtil({
      productVariantSample,
      sampledData
    })
  }
)

export default getImageToDisplayOnCardSelector
